import React from 'react';
import Button from 'react-bootstrap/Button';

export default (props) => {

  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <aside>
      <div className="description">Items with Actions</div>
      <div className="dndnode" onDragStart={(event) => onDragStart(event, 'visibility')} draggable>
        Visibilty Settings
      </div>
      <br />
      <div className="dndnode" onDragStart={(event) => onDragStart(event, 'condition')} draggable>
        Condition Node
      </div>
      <br />
      <div className="dndnode" onDragStart={(event) => onDragStart(event, 'option')} draggable>
        Option Settings
      </div>
      <br />
      <div className="dndnode" onDragStart={(event) => onDragStart(event, 'value')} draggable>
        Set Values
      </div>
      <br />
      <br />

      <Button variant="success" onClick={props.onSave}>Conditional Save</Button>
    </aside>
  );
};